module.exports = __webpack_public_path__ + "static/photo-94d97924536eac8b57164593c8d32dcd.png";